import { useMemo } from 'react';

import { type PageIntroHighlight } from '@/components/molecules';

import { useDeliveryRoutes } from './useDeliveryRoutes';

/**
 * The opening strip distinguishes published route estimates from destinations
 * that need a destination-specific conversation.
 */
export function useDeliveryIntroHighlights(): readonly PageIntroHighlight[] {
  const { routes } = useDeliveryRoutes();

  return useMemo(() => {
    const pricedRoutes = routes.filter((route) => route.pricing === 'published');

    return [
      { icon: 'location' as const, label: `${routes.length} named destinations` },
      { icon: 'price' as const, label: `${pricedRoutes.length} with published estimates` },
      { icon: 'chat' as const, label: 'Regional delivery by enquiry' },
    ];
  }, [routes]);
}
